;(function($, window, document){
    window.PhotoZoom = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'displayZoomedPhoto');

            this.addEvents();
                
        },
        addEvents: function() {
           this.$el.on('click', this.displayZoomedPhoto);
                //this.$el.parents('.slide').on('click','.photo-zoom', this.displayZoomedPhoto);
        },
        displayZoomedPhoto: function(e){
            console.log(e);
            Me.dispatch.emit('LIGHTBOX.ZOOM', this, {lightboxSrc:$(e.currentTarget).data('src')});
        }
    });
}(jQuery, window, document));
